<template>
    <pop
        :animation="animationType || 'fadeInRight'"
        customClass="detail-pop-wrap"
        :enableAnimation="enableAnimation"
        :showMask="false"
        :allowClose="false"
    >
        <div
            ref="iframeWrap"
            v-loading="loading"
            loading-mask="true"
            class="detail-pop-container"
        ></div>
    </pop>
</template>
<script>
export default {
    data: function () {
        return {
            loading: false,
            enableAnimation: true,
            animationType: this.animation
        };
    },
    props: ['animation'],
    watch: {
        animation(val) {
            this.animationType = val;
        }
    },
    methods: {
        refreshIframUserState() {
            this.$refs.iframeWrap.children[0].contentWindow.siteAppVm.$store.dispatch(
                'getUser',
                { checkOtherIframe: false }
            );
        },
        // md-detaiul-info of banner which will call
        hide: function () {
            window.history.back();
            this.display(false);
        },
        setLink: function (link) {
            if (link) {
                var popstateFunc = event => {
                    event.preventDefault();
                    window.removeEventListener('popstate', popstateFunc);
                    //  Go back to the page with gestures on the mobile terminal ,  no need for animation
                    this.setEnableAnimation(false);
                    this.display(false);
                };
                window.addEventListener('popstate', popstateFunc);

                if (this.link === link) {
                    window.history.pushState({}, null, link);
                } else {
                    this.$nextTick(() => {
                        this.$refs.iframeWrap.innerHTML = `<iframe src="${link}" class="detail-pop" frameborder="0" ></iframe>`;
                        this.$refs.iframeWrap.focus();
                    });
                    this.updateLink(link);
                    window.__curDetailPop = this;
                }
            }
        },
        // iframe of link When changing, this method will be called to change the record of the pop-up window link
        updateLink: function (link) {
            this.setLoading(true);
            window.history.pushState({}, null, link);
            this.link = link;
        },
        //  Revise loading state
        setLoading: function (loading) {
            this.loading = loading;
        },
        //  Revise enableAnimation
        setEnableAnimation: function (enableAnimation) {
            this.enableAnimation = enableAnimation;
        },
        //  Modify the pop-up direction
        setAnimation: function (animation) {
            this.animationType = animation;
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.detail-pop-wrap {
    display: block;
    width: 100%;
    height: 100%;
    background: #fff;
}
.detail-pop {
    display: block;
    width: 100vw;
    height: 100vh;
    background: #fff;
}
.detail-pop-container {
    -webkit-overflow-scrolling: touch;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    iframe {
        max-height: 100%;
    }
}
</style>
